import React from 'react';
type TextFieldProps = {
  label: string;
  name: string;
  error?: string;
  hint?: React.ReactNode;
  optional?: boolean;
  tone?: 'light' | 'dark';
  className?: string;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name' | 'className'>;
export function TextField({
  label,
  name,
  error,
  hint,
  optional,
  tone = 'light',
  className = '',
  id,
  ...rest
}: TextFieldProps) {
  const fieldId = id ?? `f-${name}`;
  const describedBy = [hint ? `${fieldId}-hint` : '', error ? `${fieldId}-err` : ''].filter(Boolean).join(' ') || undefined;
  const labelColor = tone === 'dark' ? 'text-cream' : 'text-charcoal';
  const subColor = tone === 'dark' ? 'text-cream/75' : 'text-graphite';
  return <div className={className} data-id="element-218" data-mp="3e9kiug2jp31q">
      <label htmlFor={fieldId} className={`flex items-baseline justify-between gap-3 text-[0.7rem] font-medium uppercase tracking-[0.2em] ${labelColor}`} data-id="element-219" data-mp="3e9u3do4tmi01">
        <span data-id="element-220" data-mp="2lrga81ufjk7a">{label}</span>
        {optional && <span className={`text-xs font-normal normal-case tracking-normal ${subColor}`} data-id="element-221" data-mp="2lqew1oi4ahlc">Optional</span>}
      </label>
      <input id={fieldId} name={name} aria-invalid={error ? true : undefined} aria-describedby={describedBy} className={`field mt-2 ${tone === 'dark' ? 'field-dark' : ''}`} {...rest} data-id="element-222" data-mp="1hkiwu61xl5p2" />
      {hint && <p id={`${fieldId}-hint`} className={`mt-2 text-sm leading-relaxed ${subColor}`} data-id="element-223" data-mp="13qi8m68lv12y">
          {hint}
        </p>}
      {error && <p id={`${fieldId}-err`} className={`mt-2 text-sm ${tone === 'dark' ? 'text-blush' : 'text-[#9B2C2C]'}`} data-id="element-224" data-mp="tt3q8134g280">
          {error}
        </p>}
    </div>;
}